var _linearGradient, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpensesAndRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_66101c6e5dbe0b445b5b00515cd8dae9c96be6dc34fd800b94253a2460008b61",
    gradientUnits: "userSpaceOnUse",
    x1: 41.87,
    y1: 31.67,
    x2: 58.68,
    y2: 31.67
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M19.24 59.52h46.52M26.94 27.32H42.5v27.62H26.94z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_0_66101c6e5dbe0b445b5b00515cd8dae9c96be6dc34fd800b94253a2460008b61)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M65.84 22.24h5.3v-9.43h3.68l-6.64-6.33-6.1 6.49h3.76v9.27z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M19.16 32.4h-5.3v9.43h-3.68l6.64 6.33 6.1-6.48h-3.76V32.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_0_66101c6e5dbe0b445b5b00515cd8dae9c96be6dc34fd800b94253a2460008b61)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M53.44 54.94l4.62-4.61M44.47 54.94l13.59-13.59M42.5 47.94l15.56-15.56M42.52 38.94l15.23-15.23M42.51 29.98l15.55-15.55M42.51 21.74L55.67 8.58M42.51 13.49l5.05-5.05M42.5 8.4h15.56v46.54H42.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M10.51 27.32h2.48M15.46 27.32h2.47M20.4 27.32h2.48M62.26 27.32h2.48M67.21 27.32h2.48M72.16 27.32h2.48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpensesAndRevenue);
export default __webpack_public_path__ + "static/media/expensesAndRevenue.5e90b65e15c0082b854d66906824bb1a.svg";
export { ForwardRef as ReactComponent };